module.exports = __webpack_public_path__ + "img/video-gray.13e3b74b.svg";